import Vue from 'vue'

import {
  Button,
  Input,
  Row,
  Col,
  Pagination,
  Popover,
  Loading
} from 'element-ui'

Vue.use(Button)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Loading.directive)



// WEBPACK FOOTER //
// ./src/utils/element-ui.js